(function () {
  'use strict';

  // ---------- Before/After comparison slider ----------
  const stage = document.querySelector('[data-pairs]');
  if (stage) {
    let pairs = [];
    try { pairs = JSON.parse(stage.getAttribute('data-pairs')); } catch (e) { pairs = []; }

    const compare   = stage.querySelector('[data-ba-compare]');
    const beforeImg = stage.querySelector('[data-ba-before]');
    const afterImg  = stage.querySelector('[data-ba-after-img]');
    const afterWrap = stage.querySelector('[data-ba-after]');
    const divider   = stage.querySelector('[data-ba-divider]');
    const labelEl   = stage.querySelector('[data-ba-label]');
    const dots      = stage.querySelectorAll('[data-ba-dot]');

    let pos = 50;
    let dragging = false;

    const setPos = (p) => {
      pos = Math.max(0, Math.min(100, p));
      afterWrap.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      divider.style.left = pos + '%';
    };

    const posFromEvent = (e) => {
      const rect = compare.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    };

    compare.addEventListener('mousedown', (e) => { dragging = true; setPos(posFromEvent(e)); });
    window.addEventListener('mouseup',    () => { dragging = false; });
    window.addEventListener('mousemove',  (e) => { if (dragging) setPos(posFromEvent(e)); });
    compare.addEventListener('touchstart', (e) => { setPos(posFromEvent(e)); }, { passive: true });
    compare.addEventListener('touchmove',  (e) => { setPos(posFromEvent(e)); }, { passive: true });
    compare.addEventListener('click',      (e) => { setPos(posFromEvent(e)); });

    const setPair = (i) => {
      const p = pairs[i]; if (!p) return;
      beforeImg.src = p.before;
      beforeImg.alt = 'Before: ' + p.label;
      afterImg.src  = p.after;
      afterImg.alt  = 'After: '  + p.label;
      labelEl.textContent = p.label;
      dots.forEach((d, idx) => d.classList.toggle('ba__dot--on', idx === i));
      setPos(50);
    };
    dots.forEach((d, idx) => d.addEventListener('click', () => setPair(idx)));
  }

  // ---------- Smooth-scroll anchor links with offset for fixed navs ----------
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + id);
    });
  });

  // ---------- Calendly inline widget ----------
  // Only injects the script if a Calendly URL was provided.
  const calendlyHost = document.querySelector('.calendly-inline-widget');
  if (calendlyHost && calendlyHost.dataset.url && calendlyHost.dataset.url.indexOf('your-handle') === -1) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  } else if (calendlyHost) {
    calendlyHost.innerHTML =
      '<div style="padding:48px 24px;text-align:center;font-family:Inter,system-ui,sans-serif;color:#5A5A78;">' +
        '<p style="font-size:15px;margin:0 0 12px;"><strong style="color:#0A0E2A;">Booking opens soon.</strong></p>' +
        '<p style="font-size:14px;margin:0;">Email <a href="mailto:hello@mjaiksuds.com" style="color:#6B6BFF;">hello@mjaiksuds.com</a> to book in the meantime.</p>' +
      '</div>';
  }
})();
